import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Table } from 'rsuite';
import { get } from 'lodash/fp';
import { UserType } from '../../../../../interfaces/portal';

const { Cell } = Table;

const GuestNameCell = ({ rowData, ...props }) => {
  const guest = get('linkedGuest', rowData);
  return (
    <Cell {...props} className="link-group">
      {guest ? (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`/manage/guest/view/${guest.id}`}
          style={{ verticalAlign: 'super' }}
        >
          {guest.name}
          <Icon icon="external-link-square" style={{ marginLeft: 5 }} />
        </a>
      ) : (
        ''
      )}
    </Cell>
  );
};

GuestNameCell.propTypes = {
  rowData: UserType,
  dataKey: PropTypes.string.isRequired
};

GuestNameCell.defaultProps = {
  rowData: null
};

export default GuestNameCell;
